<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Inventory System Check"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'inventoryReport', label: 'Inventory' },
            {
              name: 'inventorySystemCheck',
              label: 'Inventory System Check',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          :filterByItemType="true"
          @submit-filter="performGetReport"
          :isLoading="inventoryTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Item Id</th>
                  <th align="left">Batch #</th>
                  <th align="right">Purchased</th>
                  <th align="right">Sold</th>
                  <th align="right">Disposed</th>
                  <th align="right">Adjusted</th>
                  <th align="right">Returned</th>
                  <th align="right">On Hand</th>
                  <th align="right">On Hand Diff</th>
                  <th align="right">WI</th>
                  <th align="right">WI Diff</th>
                  <th align="right">Item PO</th>
                  <th align="right">Order PO</th>
                  <th align="right">PO Diff</th>
                  <th align="right">Scheduled</th>
                  <th align="right">Available</th>
                  <th align="right">Available Diff</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.item}}</td>
                  <td>{{ record.batchId}}</td>
                  <td align="right">{{ record.purchased}}</td>
                  <td align="right">{{ record.sold}}</td>
                  <td align="right">{{ record.disposed}}</td>
                  <td align="right">{{ record.adjusted}}</td>
                  <td align="right">{{ record.returned}}</td>
                  <td align="right">{{ record.onHand}}</td>
                  <td align="right">{{ record.diff1}}</td>
                  <td align="right">{{ record.workingInventory}}</td>
                  <td align="right">{{ record.diff3}}</td>
                  <td align="right">{{ record.preorder}}</td>
                  <td align="right">{{ record.notPosted}}</td>
                  <td align="right">{{ record.diff5}}</td>
                  <td align="right">{{ record.scheduled}}</td>
                  <td align="right">{{ record.available}}</td>
                  <td align="right">{{ record.diff2}}</td>
                </tr>
              </tbody>
              <tr class="skip-export">
                <td colspan="100%">
                  <hr class="line1" />
                </td>
              </tr>
              <tr>
                <td colspan="2">Totals</td>
                <td align="right">{{ reportData.total.purchased}}</td>
                <td align="right">{{ reportData.total.sold}}</td>
                <td align="right">{{ reportData.total.disposed}}</td>
                <td align="right">{{ reportData.total.adjusted}}</td>
                <td align="right">{{ reportData.total.returned}}</td>
                <td align="right">{{ reportData.total.onHand}}</td>
                <td align="right">{{ reportData.total.diff1}}</td>
                <td align="right">{{ reportData.total.workingInventory}}</td>
                <td align="right">{{ reportData.total.diff3}}</td>
                <td align="right">{{ reportData.total.preorder}}</td>
                <td align="right">{{ reportData.total.notPosted}}</td>
                <td align="right">{{ reportData.total.diff5}}</td>
                <td align="right">{{ reportData.total.scheduled}}</td>
                <td align="right">{{ reportData.total.available}}</td>
                <td align="right">{{ reportData.total.diff2}}</td>
              </tr>
              <tr class="skip-export"></tr>
              <tr class="skip-export">
                <td colspan="100%"><hr class="line1" /></td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Inventory System Check");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        inventoryTransactions: "reports/inventoryTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getSalesTransactions: "reports/getInventoryTransactions",
      }),
      performGetReport(filter) {
        let reportType = "inventorySystemCheck";
        this.getSalesTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "inventorySystemCheck");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_inventorySystemCheck.scss";